import React, { useState, useEffect, useRef } from "react";
import { useCartContext } from "../context/CartContext";
import { Link, useNavigate } from "react-router-dom";
import { fetchRecommendedProduct } from "../api/apiService";
// import { BASE_URL } from '../constants';

import {
  Navbar,
  Container,
  Nav,
  Form,
  FormControl,
  Row,
  Col,
  Modal,
  Button
} from "react-bootstrap";

import "bootstrap-icons/font/bootstrap-icons.css";
import { BASE_URL } from "../constants";
import LoginModal from "../Components/LoginModal";

const logo = "/assets/images/menu/logo/redCarat-01.png";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const { cart, deleteItemFromCart, updateQuantity,addItemToCart } = useCartContext();
  const [cartItems, setCartItems] = useState([]);
  const [reomndedItems, setReomndedItems] = useState([]);
  const navigate = useNavigate();
  const [selectedColor, setSelectedColor] = useState("gold");
  const [selectedSize, setSelectedSize] = useState("M");
  const [giftWrap, setGiftWrap] = useState(false);
  const [qty, setQty] = useState(1);
  const [activeDeal, setActiveDeal] = useState(0);
  const [openAccordion, setOpenAccordion] = useState(null);
  const [wishlisted, setWishlisted] = useState(false);
  const [addedToCart, setAddedToCart] = useState(false);
  const [activeImage, setActiveImage] = useState(0);
  const [cartOpen, setCartOpen] = useState(false);
  const [cartQty, setCartQty] = useState(1);
  const [coupon, setCoupon] = useState("");
  const [showBreakdown, setShowBreakdown] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const handleCloseLogin = () => setShowLoginModal(false);
  const handleShowLogin = () => setShowLoginModal(true);

  // ✅ NEW USER STATE (ADDED ONLY)
  const [user, setUser] = useState(null);
  const [userMenuOpen, setUserMenuOpen] = useState(false);

  // const [userMenuOpen, setUserMenuOpen] = useState(false);
  // ✅ FIX: stable hover timeout
  const ref = useRef();
  const hoverTimeoutRef = useRef(null);
  const hideTimeout = useRef(null);

  const BASE_PRICE = 2659;
  const GIFT_WRAP_PRICE = 50;
  // // const itemTotal = BASE_PRICE * cartQty;
  const giftWrapTotal = giftWrap ? GIFT_WRAP_PRICE : 0;
  // const discount = Math.round(itemTotal * 0.3);
  // const estimatedTotal = itemTotal + giftWrapTotal;
  const toggleSubmenu = (menu) => {
    setOpenSubmenu(openSubmenu === menu ? null : menu);
  };

  const colors = [
    { id: "gold", label: "Gold", hex: "#C9A84C" },
    { id: "rose", label: "Rose Gold", hex: "#E8B4B8" },
  ];

  const safeCart = Array.isArray(cart.cartItems) ? cart.cartItems : [];


  const categoryIds = [];

  // const toggleCart = () => {
  //   setCartOpen(prev => !prev);
  //   // Store category ids
  //   // safeCart.forEach(item => {
  //   //   if (item.category_id) {
  //   //     categoryIds.push(item.category_id);
  //   //   }
  //   // });
  //   // if (categoryIds.length > 0) {

  //   //   try {
  //   //     if (cart?.cartItems.length > 0) {

  //   //       const response = await fetchRecommendedProduct({
  //   //         categoryIds
  //   //       });
  //   //     }

  //   //   } catch (err) {

  //   //     console.log(err);

  //   //     alert(err.message);
  //   //   }
  //   // }

  // };
const toggleCart = async () => {

  // Open / Close Cart
  setCartOpen(prev => !prev);

  try {

    // Safe cart items
    const safeCart = Array.isArray(cart?.cartItems)
      ? cart.cartItems
      : [];

    // Get unique category ids
    const categoryIds = [
      ...new Set(
        safeCart
          .map(item => item.category_id)
          .filter(Boolean)
      )
    ];

    // Stop if no categories
    if (!categoryIds.length) return;

    // Call Recommended Product API
    const response = await fetchRecommendedProduct({
      categoryIds
    });
    setReomndedItems(response.data.products)
    // Optional: store response in state
    // setRecommendedProducts(response?.data);

  } catch (err) {

    console.log(err);

    alert(err.message);
  }
};

  const cartQty1 = safeCart.reduce(
    (total, item) => total + item.quantity,
    0
  );



  // setCartQty(cartQty1);

  // console.log(cartQty,'cartQty');
  const itemTotal = safeCart.reduce(
    (total, item) => total + item.price * item.quantity,
    0
  );

  const discount = Math.round(itemTotal * 0.3);
  const estimatedTotal = itemTotal - discount;

  const proceedCheckout = () => {
     const session = localStorage.getItem("session");
    


    if (session && session !== "undefined") {
      setCartOpen(false);
      console.log(session,'session');
      navigate("/checkout");
    } else {
      setCartOpen(false);
      setShowLoginModal(true);
    }
  };

  // ✅ SAFE USER LOAD (NO CRASH)
  const loadUser = () => {
    try {
      const session = localStorage.getItem("session");

      if (!session || session === "undefined") {
        setUser(null);
        return;
      }

      setUser(JSON.parse(session));
      
    } catch (e) {
      setUser(null);
    }
  };

  useEffect(() => {
    loadUser();
  }, []);

  useEffect(() => {
    if (!showLoginModal) {
      loadUser();
    }
  }, [showLoginModal]);

  // ✅ LOGOUT
  const handleLogout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("session");

  window.location.href = "/";
  };

    // Add To Cart
  const handleAddToCart = (item) => {
    
    addItemToCart({
      product: item.id, // ✅ FIXED
      name: item.name,
      price: parseFloat(item.price),
      old_price: item.old_price || "",
      image: item.image,
      stock: 10,
      seller: item.brand || "",
      contains_in_box: "",
      product_type: "simple",
      quantity: 1,
      category_id:item.category_id || "",
    });
  };

// console.log(reomndedItems,'reomndedItems');
  return (
    <header className="main-header">
      <style>{`
      
      .main-header{
        position:sticky;
        top:0;
        z-index:999;
        background:white;
      }

      /* DESKTOP */

      .top-header{
        background:#f7f7f7;
      }

      .header-search input{
        height:45px;
        border-radius:25px;
      }

      .header-icons i{
        font-size:20px;
        cursor:pointer;
        -webkit-text-stroke:0.6px;
      }

      .header-icons i:hover{
        color:#c89c3d;
      }

      .navbar-nav .nav-link{
        font-size:15px;
        color:#000;
      }

      .navbar-nav .nav-link:hover{
        color:#c89c3d;
      }

      /* MOBILE */

      .mobile-search input{
        height:42px;
        border-radius:25px;
        background:#f3efe6;
        border:none;
      }

      /* DRAWER */

      .mobile-drawer{
        position:fixed;
        top:0;
        left:0;
        width:280px;
        height:100vh;
        background:white;
        z-index:2000;
        transform:translateX(-100%);
        transition:0.3s ease;
        overflow-y:auto;
        box-shadow:2px 0 10px rgba(0,0,0,0.1);
      }

      .mobile-drawer.open{
        transform:translateX(0);
      }

      .drawer-header{
        padding:20px;
        border-bottom:1px solid #eee;
        font-weight:600;
      }

      .drawer-menu-item{
        border-bottom:1px solid #f1f1f1;
      }

      .drawer-menu-link{
        padding:14px 20px;
        display:flex;
        justify-content:space-between;
        align-items:center;
        cursor:pointer;
      }

      .drawer-submenu{
        background:#fafafa;
      }

      .drawer-submenu a{
        padding:12px 35px;
        display:block;
        text-decoration:none;
        color:#333;
        font-size:14px;
      }

      .drawer-overlay{
        position:fixed;
        top:0;
        left:0;
        width:100%;
        height:100%;
        background:rgba(0,0,0,0.4);
        z-index:1500;
      }
.custom-person-icon{
font-size: 23px !important;
}

      /* DESKTOP SUBMENU */

.desktop-menu .dropdown-menu-custom{
  position:relative;
  cursor:pointer;
}

.desktop-menu .dropdown-menu-custom .submenu{
  position:absolute;
  top:100%;
  left:0;
  background:white;
  min-width:220px;
  box-shadow:0 5px 15px rgba(0,0,0,0.08);
  border-radius:6px;
  display:none;
  padding:10px 0;
  z-index:999;
}

.desktop-menu .dropdown-menu-custom .submenu a{
  display:block;
  padding:10px 18px;
  text-decoration:none;
  color:#333;
  font-size:14px;
}

.desktop-menu .dropdown-menu-custom .submenu a:hover{
  background:#f7f7f7;
  color:#c89c3d;
}

/* hover effect */

.desktop-menu .dropdown-menu-custom:hover .submenu{
  display:block;
}
      `}</style>

      {/* MOBILE HEADER */}

      <div className="mobile-header d-lg-none border-bottom">
        <Container>
          <Row className="align-items-center py-2">
            <Col xs={1}>
              <i
                className="bi bi-list fs-3"
                style={{ cursor: "pointer" }}
                onClick={() => setMenuOpen(true)}
              ></i>
            </Col>

            <Col xs={6} className="text-center">
              <Link to="/">
                <img
                  src={logo}
                  alt="logo"
                />
              </Link>
            </Col>


          </Row> <Col xs={5} className=" d-flex gap-2 justify-content-end">
            <i className="bi bi-heart"></i>
            <i className="bi bi-bag" onClick={toggleCart}>{cartQty1}</i>
            <span className="cart-count-badge">8</span>
            <i className="bi bi-person custom-person-icon" onClick={() => setShowLoginModal(true)}
              style={{ cursor: "pointer" }}></i>


          </Col>

          {/* MOBILE SEARCH */}

          <Row className="pb-3">
            <Col>
              <Form className="mobile-search position-relative">
                <input
                  type="text"
                  className="form-control ps-4"
                  placeholder="Search for Necklace"
                />
                <i className="bi bi-search position-absolute top-50 end-0 translate-middle-y me-3"></i>
              </Form>
            </Col>
          </Row>
          <Col xs={5} className="d-flex gap-2 justify-content-end">
            <i className="bi bi-heart"></i>
            <i className="bi bi-bag" onClick={toggleCart}>{cartQty1}</i>

            {/* ✅ USER (ADDED ONLY FUNCTIONALITY) */}
            <div
              style={{ position: "relative", cursor: "pointer", display: "flex", gap: "6px", alignItems: "center" }}
              onMouseEnter={() => setUserMenuOpen(true)}
              onMouseLeave={() => setUserMenuOpen(false)}
              onClick={() => !user && setShowLoginModal(true)}
            >
              <i className="bi bi-person custom-person-icon"></i>

              <span>
                {user?.name?.trim() ? user.name : user?.telephone || ""}
              </span>

              {userMenuOpen && user && (
                <div className="user-popup">
                  <button onClick={handleLogout}>Logout</button>
                   
                </div>
              )}
            </div>

          </Col>
        </Container>
      </div>

      {/* MOBILE DRAWER */}

      <div className={`mobile-drawer ${menuOpen ? "open" : ""}`}>
        <div className="drawer-header d-flex justify-content-between">
          Menu
          <i
            className="bi bi-x-lg"
            style={{ cursor: "pointer" }}
            onClick={() => setMenuOpen(false)}
          ></i>
        </div>

        <div className="drawer-menu">
          <div className="drawer-menu-item">
            <a className="drawer-menu-link" href="#">
              Latest Designs
            </a>
          </div>
          <div className="drawer-menu-item">
            <a className="drawer-menu-link" href="#">
              All Products
            </a>
          </div>

          <div className="drawer-menu-item">


            {openSubmenu === "collections" && (
              <div className="drawer-submenu">
                <a href="#">By category</a>
                <a href="#">By types</a>
                {/* <a href="#">Bracelets</a> */}
              </div>
            )}
          </div>

          <div className="drawer-menu-item">
            <div
              className="drawer-menu-link"
              onClick={() => toggleSubmenu("category")}
            >
              Shop By Category
              <i
                className={`bi ${openSubmenu === "category"
                  ? "bi-chevron-up"
                  : "bi-chevron-down"
                  }`}
              ></i>
            </div>

            {openSubmenu === "category" && (
              <div className="drawer-submenu">
                <a href="#">Earrings</a>
                <a href="#">Necklaces</a>
                <a href="#">Rings</a>
                <a href="#">Bracelets</a>
              </div>
            )}
          </div>

          <div className="drawer-menu-item">
            <a className="drawer-menu-link" href="#">
              About Us
            </a>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div
          className="drawer-overlay"
          onClick={() => setMenuOpen(false)}
        ></div>
      )}

      {/* DESKTOP HEADER */}

      <div className="desktop-header d-none d-lg-block">
        <div className="top-header py-3 border-bottom">
          <Container>
            <div className="d-flex align-items-center justify-content-between">
              <div className="logo">
                <Link to="/">
                  <img
                    src={logo}
                    alt="logo"
                  />
                </Link>
              </div>

              <div className="header-search w-50">
                <Form className="position-relative">
                  <FormControl
                    type="search"
                    placeholder="Enter your search key ..."
                    className="ps-5 rounded-pill"
                  />
                  <i className="bi bi-search position-absolute top-50 start-0 translate-middle-y ms-3"></i>
                </Form>
              </div>

              {/* DESKTOP ICON FIXED SAME LOGIC */}
              {/* ================= DESKTOP HEADER USER FIX ================= */}
              <div className="header-icons d-flex gap-4">

                <i className="bi bi-heart"></i>

                <i className="bi bi-bag" onClick={toggleCart}>
                  {cartQty1}
                </i>

                {/* USER */}
                <div
                  style={{
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    cursor: "pointer"
                  }}
                  onMouseEnter={() => {
                    clearTimeout(hoverTimeoutRef.current);
                    setUserMenuOpen(true);
                  }}
                  onMouseLeave={() => {
                    hoverTimeoutRef.current = setTimeout(() => {
                      setUserMenuOpen(false);
                    }, 200);
                  }}
                  onClick={() => !user && setShowLoginModal(true)}
                >
                  <i className="bi bi-person custom-person-icon"></i>

                  <span>
                    {user?.name?.trim()
                      ? user.name
                      : user?.telephone || "Login"}
                  </span>

                  {userMenuOpen && user && (
                    <div
                      style={{
                        position: "absolute",
                        top: "35px",
                        right: 0,
                        background: "#fff",
                        padding: "10px",
                        borderRadius: "6px",
                        boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
                        zIndex: 9999
                      }}
                      onMouseEnter={() =>
                        clearTimeout(hoverTimeoutRef.current)
                      }
                      onMouseLeave={() => setUserMenuOpen(false)}
                    >
                      <button onClick={handleLogout}>Logout</button>
                       <button onClick={handleLogout}>Acoount</button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Container>
        </div>

        <Navbar expand="lg">
          <Container>
            <Nav className="mx-auto gap-3 desktop-menu">
              <Nav.Link href="#">Latest Designs</Nav.Link>
              <Nav.Link href="#">All Products</Nav.Link>

              {/* SHOP COLLECTIONS */}


              {/* SHOP CATEGORY */}
              <div className="nav-item dropdown-menu-custom">
                <span className="nav-link">
                  Shop By Category <i className="bi bi-chevron-down"></i>
                </span>

                <div className="submenu">
                  <a href="#">Earrings</a>
                  <a href="#">Necklaces</a>
                  <a href="#">Rings</a>
                  <a href="#">Bracelets</a>
                  <a href="#">Anklets</a>
                </div>
              </div>
              <div className="nav-item dropdown-menu-custom">
                <span className="nav-link">
                  Shop By Type <i className="bi bi-chevron-down"></i>
                </span>

                <div className="submenu">
                  <a href="#">Stud Earrings</a>
                  <a href="#">Statement Earrings</a>
                  <a href="#">Statement necklace</a>
                  <a href="#">Hoops Earrings</a>
                  <a href="#">Bracelets</a>

                </div>
              </div>
              <div className="nav-item dropdown-menu-custom">
                <span className="nav-link">
                  Traditional Jewelry <i className="bi bi-chevron-down"></i>
                </span>

                <div className="submenu">
                  <a href="#">Traditional Earrings</a>
                  <a href="#">Traditional Necklaces</a>
                  {/* <a href="#">Rings</a> */}
                  <a href="#">Traditional Bangles</a>
                  <a href="#">Anklets</a>
                </div>
              </div>

              <div className="nav-item dropdown-menu-custom">
                <span className="nav-link">
                  Accessories <i className="bi bi-chevron-down"></i>
                </span>

                <div className="submenu">
                  <a href="#">Brooches</a>
                  <a href="#">Jewellery pouches/box</a>
                  {/* <a href="#">Rings</a> */}
                  <a href="#">Hair jewelry</a>
                  {/* <a href="#">Anklets</a> */}
                </div>
              </div>

              <div className="nav-item dropdown-menu-custom">
                <span className="nav-link">
                  Shop By Price <i className="bi bi-chevron-down"></i>
                </span>

                <div className="submenu">
                  {/* <a href="#">Under 49 AED</a> */}
                  <a href="#">Under 149 AED</a>
                  <a href="#">Under 249 AED</a>
                  <a href="#">Under 349 AED</a>
                </div>
              </div>

              {/* <Nav.Link href="#">Accessories</Nav.Link>
              <Nav.Link href="#">Shop by Price</Nav.Link> */}
              {/* <Nav.Link href="#">About Us</Nav.Link> */}
            </Nav>
          </Container>
        </Navbar>
        {cartOpen && (
          <>
            <div className="cart-overlay" onClick={() => setCartOpen(false)} />
            <div className="cart-drawer">

              {/* HEADER */}
              <div className="cart-header">
                <span className="cart-header-title">Your Cart ({cartQty1} item{cartQty1 > 1 ? "s" : ""})</span>
                <button className="cart-close" onClick={() => setCartOpen(false)}>✕</button>
              </div>
              <div className="cart-promo-banner">
                🎁 FREE STUDS of ₹1495 on orders above ₹2999
              </div>

              {/* SCROLLABLE BODY */}
              <div className="cart-body">

                {Array.isArray(safeCart) && safeCart.length > 0 ? (
                  safeCart.map((item, index) => (
                    <div className="cart-item" key={index}>

                      <div className="cart-item-img">
                        <img
                          src={
                            BASE_URL + item.image ||
                            "https://placehold.co/60x60/F5F0EA/C9A84C?text=✦"
                          }
                          alt="Bangle"
                        />
                      </div>

                      <div className="cart-item-info">

                        <div className="cart-item-name">
                          {item.name}
                        </div>

                        <div className="cart-item-variant">
                          {item.variant || ""}
                        </div>

                        <div className="cart-item-bottom">

                          <div className="cart-item-qty">
                            <button
                              className="cart-qty-btn"
                              onClick={() =>
                                updateQuantity(
                                  item.product,
                                  item.quantity - 1
                                )
                              }
                            >
                              −
                            </button>

                            <span className="cart-qty-num">
                              {item.quantity}
                            </span>

                            <button
                              className="cart-qty-btn"
                              onClick={() =>
                                updateQuantity(
                                  item.product,
                                  item.quantity + 1
                                )
                              }
                            >
                              +
                            </button>
                          </div>

                          <span className="cart-item-price">
                            ₹
                            {(
                              (item.price || 0) * item.quantity
                            ).toLocaleString("en-IN")}
                          </span>

                          <button
                            className="cart-item-delete"
                            title="Remove"

                            onClick={() =>
                              deleteItemFromCart(item.product)
                            }
                          >
                            🗑
                          </button>

                        </div>
                      </div>

                    </div>
                  ))
                ) : (
                  <div className="cart-item">
                    <div className="cart-item-info">
                      Cart is empty
                    </div>
                  </div>
                )}

                <div className="view-offers">View All Offers &nbsp;›</div>

                {/* RECOMMENDED */}
                {/* <div>
                  <div className="rec-label">Recommended For You</div>
                  <div className="rec-cards">
                    {[
                      { name: "Pearl Drop Earrings", price: "₹1,299", icon: "💎" },
                      { name: "Gold Chain Necklace", price: "₹2,199", icon: "📿" },
                      { name: "Stackable Ring Set", price: "₹899", icon: "💍" },
                      { name: "Charm Anklet", price: "₹749", icon: "✨" },
                    ].map((r, i) => (
                      <div key={i} className="rec-card">
                        <div className="rec-card-img">{r.icon}</div>
                        <div className="rec-card-name">{r.name}</div>
                        <div className="rec-card-price">{r.price}</div>
                        <button className="rec-card-add">+ Add</button>
                      </div>
                    ))}
                  </div>
                </div> */}

<div>
  <div className="rec-label">Recommended For You</div>

  <div className="rec-cards">

    {Array.isArray(reomndedItems) && reomndedItems.length > 0 ? (
      reomndedItems.map((r, i) => (
        <div key={i} className="rec-card">

          <div className="rec-card-img">
            {r.image ? (
              <img src={BASE_URL + r.image} alt={r.name} />
            ) : (
              "📦"
            )}
          </div>

          <div className="rec-card-name">{r.name}</div>

          <div className="rec-card-price">₹{r.price}</div>

          <button className="rec-card-add"   onClick={() => handleAddToCart(r)}>+ Add</button>

        </div>
      ))
    ) : (
      <div>No recommendations found</div>
    )}

  </div>
</div>

                {/* OFFERS STRIP */}
                <div className="offers-strip">
                  <div className="offers-strip-left">
                    <span className="offers-strip-icon">🎟</span>
                    <span className="offers-strip-text">Extra <strong>Offers</strong> and <strong>Gift Vouchers</strong></span>
                  </div>
                  <button className="collect-btn">Collect &nbsp;›</button>
                </div>

              </div>

              {/* FOOTER */}
              <div className="cart-footer">
                <div className="estimated-total-row">
                  <span className="est-total-label">
                    Estimated Total
                    <span
                      className={`est-total-toggle ${showBreakdown ? "open" : ""}`}
                      onClick={() => setShowBreakdown(!showBreakdown)}
                    >▾</span>
                  </span>
                  <span className="est-total-amount">₹{estimatedTotal.toLocaleString("en-IN")}</span>
                </div>

                {showBreakdown && (
                  <div className="est-total-breakdown">
                    <div className="breakdown-row"><span>Subtotal ({cartQty} item{cartQty > 1 ? "s" : ""})</span><span>₹{(BASE_PRICE * cartQty + Math.round(BASE_PRICE * cartQty * 0.3)).toLocaleString("en-IN")}</span></div>
                    <div className="breakdown-row discount"><span>Discount (30%)</span><span>−₹{discount.toLocaleString("en-IN")}</span></div>
                    {giftWrap && <div className="breakdown-row"><span>Gift Wrap</span><span>₹{GIFT_WRAP_PRICE}</span></div>}
                    <div className="breakdown-row"><span>Shipping</span><span style={{ color: "#1A6B3A" }}>FREE</span></div>
                    <div className="breakdown-row total"><span>Total</span><span>₹{estimatedTotal.toLocaleString("en-IN")}</span></div>
                  </div>
                )}

                <button className="btn-checkout">
                  <span onClick={proceedCheckout}>Proceed to Checkout</span>
                  <span>→</span>
                </button>
                <div className="payment-icons">
                  <span>Secure payment via</span>
                  <span className="payment-badge">UPI</span>
                  <span className="payment-badge">Card</span>
                  <span className="payment-badge">NetBanking</span>
                </div>
              </div>

            </div>
          </>
        )}
      </div>
      <LoginModal show={showLoginModal} onClose={() => setShowLoginModal(false)} logo={logo} />
    </header>
  );
};

export default Header;
